export default{
    //Link que lleva a la consulta de aforo de las estaciones en información de la estación
    aforo: process.env.VUE_APP_CDIAC+'aforo.php',

    //Links  para consultar las rutas de los pdfs e imágenes de cada estación en Galería y en la hoja de vida
    galery_images: process.env.VUE_APP_CDIAC+'gestion-riesgo/web/resources/uploads/images/',
    galery_pdf: process.env.VUE_APP_CDIAC+'hv',

    //Links del menú en la cabezera de la página
    cdiac: process.env.VUE_APP_CDIAC+'indicadores/public/index',
    facebook: 'https://www.facebook.com/SIMACUNAL/',
    inicio: process.env.VUE_APP_CDIAC+'geoportal-simac',
    reporte_metereologico: 'http://idea.manizales.unal.edu.co/reporte-meteorologico.html',
    generar_reporte: process.env.VUE_APP_CDIAC+'gestion-riesgo/web/app.php/gestion_riesgo/generar_reporte/seleccionar_tipo_reporte',
    reporte_grafico: process.env.VUE_APP_CDIAC+'gestion-riesgo/web/app.php/gestion_riesgo/generar_reporte/seleccionar_tipo_reporte_grafico',
    twitter: 'https://twitter.com/simac_unal',
    email: process.env.VUE_APP_CDIAC+'gestion-riesgo/web/gestion_riesgo/solicitud_informacion/seleccionar_formulario',
    idea: 'http://idea.manizales.unal.edu.co'
}